import { render, staticRenderFns } from "./NotEnough.vue?vue&type=template&id=9895f3c0&scoped=true"
import script from "./NotEnough.vue?vue&type=script&lang=js"
export * from "./NotEnough.vue?vue&type=script&lang=js"
import style0 from "./NotEnough.vue?vue&type=style&index=0&id=9895f3c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9895f3c0",
  null
  
)

export default component.exports